import { Enrol } from './widgets';

export const TravelEnrolPage = () => {
  return <Enrol />;
};
